export const options = {
  poll: 'poll',
  results: 'results',
  questions: 'questions',
  dataTreatmentLink: 'dataTreatmentLink'
}
